import { useIntl } from "react-intl"
import { ConfigProvider, FormProps } from "antd"
import meetingStore from 'store/meetingStore'
import { MeetingModel } from 'api/meeting-model'
import { useSearchParams } from "react-router"
import { getVotesAccountList, getVotesDetailList, getVotesList, getVotesQuery, getVotesStat } from "api/vote"
import { ymdhms } from "utils/date-format"
import { UploadOutlined } from "@ant-design/icons"
import { utils, writeFile } from "xlsx"

export default function SurveyPage() {

  const intl = useIntl()

  const { meetingInfo } = meetingStore();

  const [locationSearch] = useSearchParams();
  const meetingIdInQuery = locationSearch.get('meeting_id') ?? meetingInfo?.meeting_id;

  const [currentMeeting, setCurrentMeeting] = useState<MeetingModel | null>(meetingInfo)

  const [searchParams, setSearchParams] =
    useState({
      meeting_id: meetingInfo?.meeting_id ?? '',
    })

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [userData, setUserData] = useState<any[]>([]);
  const [loadingExport, setLoadingExport] = useState(false);

  useEffect(() => {
    getVotesQuery(currentMeeting?.meeting_id!).then(res => {
      if (res.code == 0) {
        if (res.data != null && res.data.meeting_vote != null) {
          const tempData = JSON.parse(res.data.meeting_vote);
          setData(tempData);

          const tempUserData = JSON.parse(res.data.meeting_user);
          setUserData(tempUserData);
        }
        else {
          //显示没有归档的数据
          getVotesList(currentMeeting?.meeting_id!).then(res => {
            if (res.code == 0) {
              setData(res.data);

            }
          });
        }
      }
      setLoading(false);
    })
    // getVotesList(currentMeeting?.meeting_id!).then(res => {
    //   if (res.code == 0) {
    //     setData(res.data);
    //   }
    // });
    // setLoading(false);
  }, [currentMeeting])

  // 获取状态
  const getStatus = (value?: number) => {
    if (value === 2) {
      return intl.formatMessage({ id: "survey.page.status.ended" })
    } else if (value === 3) {
      return intl.formatMessage({ id: "survey.page.status.published" })
    } else {
      return intl.formatMessage({ id: "survey.page.status.in_progress" })
    }
  }

  const columns = useMemo<TableProps<any>['columns']>(() => {
    return [
      {
        title: intl.formatMessage({ id: "survey.page.title" }),
        dataIndex: 'title'
      },
      {
        title: intl.formatMessage({ id: "survey.page.description" }),
        dataIndex: 'description'
      },
      {
        title: intl.formatMessage({ id: "survey.page.status" }),
        dataIndex: 'status',
        render(value: number): string {
          return getStatus(value)
        }
      },
      {
        title: intl.formatMessage({ id: "table.organizational.create_time" }),
        dataIndex: 'create_time',
        render(value: string): string {
          return value ? dayjs.utc(value).tz(meetingInfo?.time_zone).format(ymdhms) : '-'
        }
      }
    ];
  }, [currentMeeting, intl.locale])


  const meetingLoadFinishHandler = async () => {
    if (meetingIdInQuery != null) {
    }
  }

  const meetingChangeHandler: MeetingSelectProps['onMeetChange'] = async (
    value: string,
    option
  ) => {
    if (option != undefined) {
      setCurrentMeeting(option!.meeting)
      setTimeout(async () => {
      })
    }
  }

  const searchChangeHandler: FormProps<any>['onValuesChange'] =
    (changedValues, allValues) => {
      setSearchParams({ ...searchParams, ...allValues })
    }

  const excelColumns = 4;

  //  生成excel
  const downloadExcelAll = async () => {
    setLoadingExport(true);

    //构建投票数据
    let voteList: any[] = [];

    //获取投票列表

    for (let index = 0; index < data.length; index++) {
      const voteInfo = data[index];

      if (voteInfo) {
        //获取投票数量
        const voteCount = await getVotesStat(meetingInfo?.meeting_id!, voteInfo.id);

        const vote: any = {
          voteId: voteInfo.id,
          title: voteInfo.title,
          questions: [],
          desc: voteInfo.description,
          status: voteInfo.status
        };


        vote.total = voteCount.data.total;

        //问题
        let questions: any[] = [];
        const temQuestions: any[] = JSON.parse(voteInfo.question_json);

        temQuestions.forEach(question => {
          const tempQuestion: any = {
            question_id: question.question_id,
            title: question.title,
            type: question.type,
            required: question.required,
            options: [],
          };

          //选项
          const questionCount = voteCount.data.stat[question.question_id];

          let total = 0;
          for (let key in questionCount) {
            total += questionCount[key];
          }

          question.options.forEach((option: any) => {
            let progress = 0;
            if (total > 0) {
              progress = Math.round(((questionCount[option.option_id] ?? 0) * 100 / total) * 100) / 100;
            }

            const optionTotal = questionCount && questionCount.hasOwnProperty(option.option_id) ? questionCount[option.option_id] : 0;

            const tempOption: any = {
              option_id: option.option_id,
              text: option.text,
              total: optionTotal,
              progress: progress,
            };

            tempQuestion.options.push(tempOption);
          });

          questions.push(tempQuestion);
        });

        vote.questions = questions;

        voteList.push(vote);
      }
    };


    if (voteList.length > 0) {

      const workbook = utils.book_new();

      for (let voteIndex = 0; voteIndex < voteList.length; voteIndex++) {
        const tempVote = voteList[voteIndex];

        if (tempVote) {

          let tempExcelData = buildExcelVoteData(tempVote);

          const userData = await buildExcelVoteUserData(tempVote);

          tempExcelData = tempExcelData.concat(userData);

          const worksheet = utils.aoa_to_sheet(tempExcelData);

          if (!worksheet["!cols"]) worksheet["!cols"] = [];

          for (let index = 0; index < Math.max(excelColumns, userData[1].length); index++) {
            if (!worksheet["!cols"][index]) {
              worksheet["!cols"][index] = { wch: 8 };
              worksheet["!cols"][index].wpx = 180;
            }
          }

          const voteNum = voteIndex + 1;

          utils.book_append_sheet(
            workbook,
            worksheet,
            'vote' + voteNum,
          );
        }
      }

      const date = dayjs().format('YYYYMMDD_HHmmss');

      const res = writeFile(workbook, `vote-${date}.xlsx`);
    }

    setLoadingExport(false);
  }

  // 生成excel数据
  const buildExcelVoteData = (vote: any) => {
    let tempExcelData: any[] = [];
    tempExcelData.push([meetingInfo?.meeting_name_zh + '/' + meetingInfo?.meeting_name_en]);
    tempExcelData.push([]);
    tempExcelData.push([vote.title]);
    tempExcelData.push([vote.desc ?? '', `${vote.total ?? '0'}${intl.formatMessage({ id: "people_have_voted" })}·${getStatus(vote.status)}`]);

    vote.questions?.forEach((element: any, index: number) => {
      const num = (index + 1).toString();
      const title = `${index < 100 ? '0' + num : num}${element.title ?? ''}[${element.type == 'single' ? intl.formatMessage({ id: "survey.page.question_type_1" }) : intl.formatMessage({ id: "survey.page.question_type_2" })}]`;
      tempExcelData.push([]);
      tempExcelData.push([title]);
      element.options?.forEach((option: any) => {
        tempExcelData.push([option.text, `${option.total ?? '0'}${intl.formatMessage({ id: "ticket" })}`, `${option.progress ?? ''}%`]);
      });
    });

    return tempExcelData;
  }

  // 生成excel用户数据
  const buildExcelVoteUserData = async (vote: any) => {
    let tempExcelData: any[] = [];
    tempExcelData.push([]);

    let tempHeader = [intl.formatMessage({ id: "survey.page.fullname" }), intl.formatMessage({ id: "survey.page.company" }), intl.formatMessage({ id: "survey.page.account" }), intl.formatMessage({ id: "survey.page.vote_time" })];

    vote.questions?.forEach((element: any, index: number) => {
      const num = (index + 1).toString();
      const title = `${index < 100 ? '0' + num : num}${element.title ?? ''}[${element.type == 'single' ? intl.formatMessage({ id: "survey.page.question_type_1" }) : intl.formatMessage({ id: "survey.page.question_type_2" })}]`;
      tempHeader.push(title);
      element.options?.forEach((option: any) => {
        tempHeader.push(option.text ?? '');
      });
    });

    tempExcelData.push(tempHeader);

    //投票详情
    const tempVoteDetails = await getVotesDetailList(meetingInfo?.meeting_id!, vote.voteId);

    const tempAccountList = await getVotesAccountList(meetingInfo?.meeting_id!, vote.voteId);

    tempAccountList.data.rows.forEach((element: any) => {
      let tempRow = [element.fullname, element.company, element.account, ''];

      //当前用户投票信息
      const tempUserVoteDetail = tempVoteDetails.data.rows.filter((detail: any) => detail.account === element.account).map((it: any) => it.option_id);

      vote.questions?.forEach((element: any) => {
        tempRow.push('');
        element.options?.forEach((option: any) => {
          if (tempUserVoteDetail.includes(option.option_id)) {
            tempRow.push('1');
          }
          else {
            tempRow.push('');
          }
        });
      });

      tempExcelData.push(tempRow);
    });

    return tempExcelData;
  }

  // 生成excel归档用户数据
  const buildExcelVoteUserQueryData = (vote: any) => {

    let tempExcelData: any[] = [];
    tempExcelData.push([]);

    let tempHeader = [intl.formatMessage({ id: "survey.page.fullname" }), intl.formatMessage({ id: "survey.page.company" }), intl.formatMessage({ id: "survey.page.account" }), intl.formatMessage({ id: "survey.page.vote_time" })];

    vote.questions?.forEach((element: any, index: number) => {
      const num = (index + 1).toString();
      const title = `${index < 100 ? '0' + num : num}${element.title ?? ''}[${element.type == 'single' ? intl.formatMessage({ id: "survey.page.question_type_1" }) : intl.formatMessage({ id: "survey.page.question_type_2" })}]`;
      tempHeader.push(title);
      element.options?.forEach((option: any) => {
        tempHeader.push(option.text ?? '');
      });
    });

    tempExcelData.push(tempHeader);

    //投票详情
    userData.forEach((userElement: any) => {
      let tempRow = [userElement.fullname, userElement.company, userElement.account];

      //当前用户投票信息
      vote.questions?.forEach((element: any) => {

        const userVote = element.options.find((o: any) => o.accounts?.some((a: any) => a.account_id == userElement.id)) || null;

        if (userVote != null) {
          tempRow.push(dayjs.utc(userVote.accounts[0].vote_time).tz(meetingInfo?.time_zone).format(ymdhms));
        }
        else {
          tempRow.push('');
        }

        tempRow.push('');
        element.options?.forEach((option: any) => {
          if (option.accounts.findIndex((a: any) => a.account_id == userElement.id) != -1) {
            tempRow.push('1');
          }
          else {
            tempRow.push('');
          }
        });
      });

      tempExcelData.push(tempRow);
    });

    return tempExcelData;
  }

  //  根据归档数据生成excel
  const downloadExcelQueryAll = () => {
    setLoadingExport(true);

    //构建投票数据
    let voteList: any[] = [];

    //获取投票列表

    for (let index = 0; index < data.length; index++) {
      const voteInfo = data[index];

      if (voteInfo) {
        const vote: any = {
          title: voteInfo.title,
          questions: [],
          desc: voteInfo.description,
          status: voteInfo.status,
          total: userData.length,
          vote_time: voteInfo.create_time
        };

        //问题
        let questions: any[] = [];
        const temQuestions: any[] = voteInfo.question_result;

        temQuestions.forEach(question => {
          const tempQuestion: any = {
            question_id: question.question_id,
            title: question.title,
            type: question.type,
            required: question.required,
            options: [],
          };

          //选项
          question.options.forEach((option: any) => {

            const tempOption: any = {
              option_id: option.option_id,
              text: option.text,
              total: option.count,
              progress: option.percent,
              accounts: option.accounts
            };

            tempQuestion.options.push(tempOption);
          });

          questions.push(tempQuestion);
        });

        vote.questions = questions;

        voteList.push(vote);
      }
    };


    if (voteList.length > 0) {

      const workbook = utils.book_new();

      for (let voteIndex = 0; voteIndex < voteList.length; voteIndex++) {
        const tempVote = voteList[voteIndex];

        if (tempVote) {

          let tempExcelData = buildExcelVoteData(tempVote);

          const userData = buildExcelVoteUserQueryData(tempVote);

          tempExcelData = tempExcelData.concat(userData);

          const worksheet = utils.aoa_to_sheet(tempExcelData);

          if (!worksheet["!cols"]) worksheet["!cols"] = [];

          for (let index = 0; index < Math.max(excelColumns, userData[1].length); index++) {
            if (!worksheet["!cols"][index]) {
              worksheet["!cols"][index] = { wch: 8 };
              worksheet["!cols"][index].wpx = 180;
            }
          }

          const voteNum = voteIndex + 1;

          utils.book_append_sheet(
            workbook,
            worksheet,
            'vote' + voteNum,
          );
        }
      }

      const date = dayjs().format('YYYYMMDD_HHmmss');

      const res = writeFile(workbook, `vote-${date}.xlsx`);
    }

    setLoadingExport(false);
  }

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Form: {
              itemMarginBottom: 15
            },
          },
        }}
      >
        <Form
          onValuesChange={searchChangeHandler}
        >
          <Flex className="tw-pt-4 tw-px-6 tw-bg-[#FBFCFF] tw-rounded-t-lg" justify="space-between">
            <Flex justify="space-around" gap="small">
              <Form.Item
                label={intl.formatMessage({ id: "table.meeting" })}
                name="meeting_id"
                initialValue={meetingIdInQuery}
              >
                <MeetingSelect
                  allowClear={false}
                  autoSelect={!meetingIdInQuery}
                  onLoadFinish={meetingLoadFinishHandler}
                  onMeetChange={meetingChangeHandler}
                />
              </Form.Item>
            </Flex>
            <Flex gap="small">
              <Button
                icon={<UploadOutlined />}
                iconPosition="end"
                loading={loadingExport}
                className="linearGradientBackgroundStyle"
                onClick={userData.length > 0 ? downloadExcelQueryAll : downloadExcelAll}
              >
                {intl.formatMessage({ id: "common.export" })}
              </Button>
            </Flex>
          </Flex>
        </Form>
      </ConfigProvider>
      <Table
        rowKey="title"
        columns={columns}
        dataSource={data}
        bordered={false}
        loading={loading}
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      <div>&nbsp;</div>
    </>
  )
}
